import { updateGrossIncome, updateIndemnityPeriod } from '../../slices/coverDetails';
import { AppDispatch } from '../../store';
import { Risk } from '../../types/policy';
import { RiskDetailBPKFireBusinessInterruption } from '../../types/risk';

export const updateBusinessInterruptionCoverAction = ({
  buildingAndContentsRisk,
  dispatch,
}: {
  buildingAndContentsRisk: Risk | undefined;
  dispatch: AppDispatch;
}) => {
  const buildingAndContentsRiskDetails = (
    buildingAndContentsRisk?.riskDetail as RiskDetailBPKFireBusinessInterruption | undefined
  )?.riskBPKFireBusinessInterruption;
  const { businessInterruption: businessInterruptionDetails } =
    buildingAndContentsRiskDetails ?? {};
  const { indemnityPeriod, grossIncomeSI } = businessInterruptionDetails!;

  dispatch(updateIndemnityPeriod(indemnityPeriod));
  grossIncomeSI && dispatch(updateGrossIncome(grossIncomeSI));
};
